import { APP_MENU_ITEMS, NAVIGATION_MENU_ITEMS } from './constants';
import { USER_ROLES } from '../auth/roles';
import type { UserRole } from '../auth/types';

export const getAppMenuItemsByRole = (role: UserRole | undefined) => {
  switch (role) {
    case USER_ROLES.AdminAbbott:
      return [
        APP_MENU_ITEMS.CustomerAdministration,
        APP_MENU_ITEMS.AbbottAdministration,
        APP_MENU_ITEMS.Education,
      ];
    case USER_ROLES.AbbottUser:
      return [APP_MENU_ITEMS.CustomerAdministration, APP_MENU_ITEMS.Education];
    case USER_ROLES.HcpAdmin:
      return [
        APP_MENU_ITEMS.Administration,
        APP_MENU_ITEMS.Outpatient,
        APP_MENU_ITEMS.Education,
      ];
    case USER_ROLES.HcpUser:
      return [APP_MENU_ITEMS.Outpatient, APP_MENU_ITEMS.Education];
    case USER_ROLES.NonHcpAdmin:
      return [APP_MENU_ITEMS.Administration, APP_MENU_ITEMS.Education];
    default:
      return [];
  }
};

export const getNavigationItemsByRole = ({
  role,
  navigationSectionId,
}: {
  role: UserRole | undefined;
  navigationSectionId:
    | (typeof APP_MENU_ITEMS)[keyof typeof APP_MENU_ITEMS]['id']
    | undefined;
}) => {
  if (role === USER_ROLES.AdminAbbott) {
    if (navigationSectionId === APP_MENU_ITEMS.AbbottAdministration.id) {
      return [
        NAVIGATION_MENU_ITEMS.AbbottUserAdministration,
        NAVIGATION_MENU_ITEMS.Archive,
      ];
    }

    if (navigationSectionId === APP_MENU_ITEMS.CustomerAdministration.id) {
      return [
        NAVIGATION_MENU_ITEMS.IDNS,
        NAVIGATION_MENU_ITEMS.Departments,
        NAVIGATION_MENU_ITEMS.CustomerUserAdministration,
        NAVIGATION_MENU_ITEMS.PatientsCustomerAdministration,
      ];
    }

    if (navigationSectionId === APP_MENU_ITEMS.Education.id) {
      // TODO: fill "education" section, when ready
      return [];
    }
  }

  if (role === USER_ROLES.HcpAdmin) {
    if (navigationSectionId === APP_MENU_ITEMS.Administration.id) {
      return [
        NAVIGATION_MENU_ITEMS.UserAdministration,
        NAVIGATION_MENU_ITEMS.DepartmentsAndSettings,
        NAVIGATION_MENU_ITEMS.Archive,
      ];
    }

    if (navigationSectionId === APP_MENU_ITEMS.Outpatient.id) {
      return [
        NAVIGATION_MENU_ITEMS.PatientAdministration,
        NAVIGATION_MENU_ITEMS.Archive,
      ];
    }

    // TODO: fill "education" and "outpatient" section, when ready
    return [];
  }

  if (role === USER_ROLES.AbbottUser) {
    if (navigationSectionId === APP_MENU_ITEMS.CustomerAdministration.id) {
      return [
        NAVIGATION_MENU_ITEMS.IDNS,
        NAVIGATION_MENU_ITEMS.Departments,
        NAVIGATION_MENU_ITEMS.UserAdministration,
        NAVIGATION_MENU_ITEMS.PatientsCustomerAdministration,
      ];
    }

    if (navigationSectionId === APP_MENU_ITEMS.Education.id) {
      // TODO: fill "education" section, when ready
      return [];
    }
  }

  // TODO: fill out the rest of the roles when available
  return [];
};

export const getIndexNavigationPathByRole = (role: UserRole | undefined) => {
  const defaultAppMenuItemId = getAppMenuItemsByRole(role)[0]?.id;
  const defaultNavigationItemPath = getNavigationItemsByRole({
    role,
    navigationSectionId: defaultAppMenuItemId,
  })[0]?.path;

  return defaultNavigationItemPath;
};
